"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XXS = exports.ITEM_WIDTH_XXS = exports.ITEM_WIDTH_XS = exports.ITEM_WIDTH = exports.ITEM_HEIGHT_XXS = exports.ITEM_HEIGHT_XS = exports.ITEM_HEIGHT = exports.DOUBLE_CURRENCY_HEIGHT_EXTENSION = void 0;
// Smallest breakpoint - we should still cover these devices for some time.
// Grid didn't look well without adjustments for these devices.
// In last version, it is not possible to add custom breakpoints into the theme (yet).
const XXS = exports.XXS = 360;
// grid item sizes
const ITEM_WIDTH = exports.ITEM_WIDTH = 155;
const ITEM_WIDTH_XS = exports.ITEM_WIDTH_XS = 143;
const ITEM_WIDTH_XXS = exports.ITEM_WIDTH_XXS = 129;
const ITEM_HEIGHT = exports.ITEM_HEIGHT = 261;
const ITEM_HEIGHT_XS = exports.ITEM_HEIGHT_XS = 251;
const ITEM_HEIGHT_XXS = exports.ITEM_HEIGHT_XXS = 241;
const DOUBLE_CURRENCY_HEIGHT_EXTENSION = exports.DOUBLE_CURRENCY_HEIGHT_EXTENSION = 20;
